import Feature from './Feature'
import Employee from './Employee'
export class EmployeeFeaturesSaveRequest {
    EmployeeID: number;
    Features: Feature[];
    SavedByEmployee: Employee;
}

export default EmployeeFeaturesSaveRequest;